module.exports = __webpack_public_path__ + "static/media/bitnovo-black.2122f718.svg";